module.exports = __webpack_public_path__ + "img/top1.1766306608134.png";